import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDiff',
  standalone: true,
})
export class TimeDiffPipe implements PipeTransform {
  transform(start: string | Date | null | undefined, end: string | Date | null | undefined): string {
    if (!start || !end) return '-';

    const startMinutes = this.toMinutes(start);
    const endMinutes = this.toMinutes(end);
    if (startMinutes === null || endMinutes === null) return '-';

    let diff = endMinutes - startMinutes;
    if (diff < 0) diff += 24 * 60; // cross midnight

    const hrs = Math.floor(diff / 60);
    const mins = diff % 60;
    return `${hrs}h ${mins}m`;
  }

  private toMinutes(input: string | Date): number | null {
    if (input instanceof Date) {
      return input.getHours() * 60 + input.getMinutes();
    }
    const str = String(input).trim();
    // Try to parse as Date string first
    const asDate = new Date(str.replace(' ', 'T'));
    if (!isNaN(asDate.getTime())) {
      return asDate.getHours() * 60 + asDate.getMinutes();
    }
    // Accept HH:mm or HH:mm:ss
    const match = str.match(/^([01]?\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/);
    if (!match) return null;
    const h = parseInt(match[1], 10);
    const m = parseInt(match[2], 10);
    return h * 60 + m;
  }
}
